export const formatPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return "";

  const cleanNumber = phoneNumber.replace(/\D/g, "");

  if (cleanNumber.length === 10) {
    return `(${cleanNumber.slice(0, 3)}) ${cleanNumber.slice(3, 6)}-${cleanNumber.slice(6)}`;
  }

  if (cleanNumber.length === 11 && cleanNumber.startsWith("1")) {
    return `+1 (${cleanNumber.slice(1, 4)}) ${cleanNumber.slice(4, 7)}-${cleanNumber.slice(7)}`;
  }

  return phoneNumber;
};
